/**
 * Base controller for badges.
 */
export default class BadgeController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    this._$attrs.$addClass('vd-badge')
  }

  /**
   * Generates badge modifiers based on current bindings.
   *
   * @method getBadgeModifiers
   *
   * @return {String} Modifiers
   */
  getBadgeModifiers() {
    const modifiers = []

    if (this.size) {
      modifiers.push(this.size)
    }

    if (this.interactive) {
      modifiers.push(`interactive-${this.interactive}`)
    }

    if (this.current) {
      modifiers.push('current')
    }

    return modifiers.join(' ')
  }

  /**
   * Generates text indicating when this entity will be permanently deleted.
   *
   * @method getMarkedForDeletionText
   *
   * @param {Object} entity A customer or user object
   *
   * @return {String} The warning text
   */
  getMarkedForDeletionText(entity) {
    const seconds = entity.time_until_deletion
    const days = Math.ceil(seconds / 60 / 60 / 24)

    return days <= 1
      ? 'Will be permanently deleted tomorrow.'
      : `Will be permanently deleted in ${days} days.`
  }

  /**
   * Checks if this entity has been marked for deletion.
   *
   * @method isMarkedForDeletion
   *
   * @param {Object} entity A customer or user object
   *
   * @return {Boolean} True if the entity has been marked for deletion
   */
  isMarkedForDeletion(entity) {
    return entity && entity.time_until_deletion > 0
  }
}
